const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = 'emptyField';
  }

  if (!values.email) {
    errors.email = 'emptyField';
  }

  if (!values.phone_number) {
    errors.phone_number = 'emptyField';
  }

  if (!values.message) {
    errors.message = 'emptyField';
  }

  return errors;
};

export default validate;
